/**
 * Etapas del embudo — estados internos (Sales_Internal_States) + mapeo (Sales_Stage_Map) vía analytics-api.
 * @module-isolated analytics-config-stages
 * @depends analytics-api.js, firebase-auth.js
 * @consumers ConfigPage / StagesConfigPanel
 */
import { fetchStageConfig, saveStageConfig } from '../../../services/analytics-api.js';
import { getIdToken } from '../../../services/firebase-auth.js';

export async function loadStageConfig(opts) {
  const token = await getIdToken(false);
  return fetchStageConfig(token, opts);
}

/**
 * @param {Array<object>} stages
 * @param {{ turnstileToken?: string, onProgress?: function }} opts
 */
export async function persistStageConfig(stages, opts) {
  const token = await getIdToken(false);
  return saveStageConfig(stages, token, opts);
}
